<div>
  <nav id="deal-nav" dense 
        mat-tab-nav-bar
        [tabPanel]="tabPanel"
        style="width: 100%"
        [ngStyle]="{'background-color': theme.subheader_bg}"
  >
    <a mat-tab-link
      *ngFor="let link of links"
      [routerLink]="link.link"
      routerLinkActive="active-link"
      [disabled]="!link.enabled"
      [ngStyle]="{'background-color':theme.subheader_bg, 'color':theme.subheader_fg}"
    >
      {{ link.title }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <div [@appFade]="animationState">
      <router-outlet></router-outlet>
    </div>
  </mat-tab-nav-panel>
</div>

